<template>
  <div :class="[$style['card-container'], { [$style.blank]: blank }]">
    <slot>Content...</slot>
  </div>
</template>

<script>
export default {
  name: "card-container",
  props: {
    blank: { type: Boolean, default: false }
  }
};
</script>

<style module lang="scss">
@import "../../style/abstract/abstract.colors";
@import "../../style/abstract/abstract.functions";
@import "../../style/abstract/abstract.spacing";

.card-container {
  box-shadow: $box-shadow;
  padding: rem-calc($spacing-l);
  background-color: $color-white;
}

.blank {
  box-shadow: none;
  background-color: transparent;
}
</style>
